import React, { useEffect } from 'react'
import { Checkbox } from '@intelie/ui'

interface ListCheckboxProps {
    checked: boolean
    onChange: (checked: boolean) => void
}

const ListCheckbox: React.FC<ListCheckboxProps> = ({ checked, onChange }: ListCheckboxProps) => {
    const [isChecked, setIsChecked] = React.useState(checked)

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        setIsChecked(event.target.checked)
        onChange(event.target.checked)
    }

    useEffect(() => {
        setIsChecked(checked)
    }, [checked])

    return <Checkbox checked={isChecked} onChange={handleChange} />
}

export default ListCheckbox
